import { InformationPipe } from '../../pipes/content/information.pipe';
import { NewsPipe } from '../../pipes/content/news.pipe';
import { RestaurantPipe } from '../../pipes/content/restaurant.pipe';
import { OpeningHoursPipe } from '../../pipes/content/opening-hours.pipe';
import { EventPipe } from '../../pipes/content/event.pipe';
import { GalleryPipe } from '../../pipes/content/gallery.pipe';
import { SocialMediaPipe } from '../../pipes/content/social-media.pipe';
import { AccommodationPipe } from '../../pipes/content/accommodation.pipe';
import { TickerPipe } from '../../pipes/content/ticker.pipe';


export const ContentPipesByContentType = new Map<string, any>([
  ['information', InformationPipe],
  ['news', NewsPipe],
  ['restaurant', RestaurantPipe],
  ['opening-hours', OpeningHoursPipe],
  ['event', EventPipe],
  ['gallery', GalleryPipe],
  ['social-media', SocialMediaPipe],
  ['accommodation', AccommodationPipe],
  ['partner', RestaurantPipe],
  ['ticker', TickerPipe]
]);
